module.exports = __webpack_public_path__ + "img/home-documents.9813d654.svg";